import { render, staticRenderFns } from "./BrowserSearch.vue?vue&type=template&id=4939dbb6&scoped=true&"
import script from "./BrowserSearch.vue?vue&type=script&lang=js&"
export * from "./BrowserSearch.vue?vue&type=script&lang=js&"
import style0 from "./BrowserSearch.vue?vue&type=style&index=0&id=4939dbb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4939dbb6",
  null
  
)

export default component.exports